import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'sw-timebar',
  templateUrl: './sw-timebar.component.html',
  styleUrls: ['./sw-timebar.component.css']
})
export class SwTimebarComponent implements OnInit {

  constructor(
    
    private box:SwMassageBoxService,
  ) { }

  /** 
   * 一天中可预约的时间段
   */
  @Input() range:string = '8:00-23:00'

  /** 
   * 已过期的时间段，不能选中
   */
  @Input() expired:any[] = []

  /** 
   * 已占用的时间段，不能选中
   */
  @Input() occupied:any[] = []

  /** 
   * 是否已读
   */
  @Input() readonly:boolean = false

  //处理后的时间段
  times:any[] = []

  //要预约的时间段
  orderTime:any[] = []

  @Output() votedOrderTime = new EventEmitter();

  ngOnInit() {
    this.init()
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.range || changes.expired || changes.occupied){
      this.setStatus()
    }
  }

  init(){
    //先获取一整天的时间段,每一格的结束时间
    let allDayTime = []
    for (let i = 0; i <= 24; i++) {
      if(i != 0){
        allDayTime.push({endTime:i+':00'})
      }
      if(i!=24){
        allDayTime.push({endTime:i+':30'})
      }
    }
    //再根据一天的工作时间段，去头去尾
    let range = this.range.split('-')
    let start = allDayTime.findIndex(item=> item.endTime == range[0])
    let end = allDayTime.findIndex(item=> item.endTime == range[1])
    allDayTime.splice(end+1)  //先删除后面的元素，会直接改变原数组
    allDayTime.splice(0,start+1)  //先删除后面的元素，会直接改变原数组
    this.times = JSON.parse(JSON.stringify(allDayTime))  //找到要渲染出来的时间段
    this.setStatus()
  }

  setStatus(){
    //将已过期时间段转化为毫秒数，根据毫秒数判断大小
    let expiredTime = []
    this.expired.forEach((v)=>{
      expiredTime.push([new Date('2020-01-01 '+ v.split('-')[0] +':00').getTime() , new Date('2020-01-01 '+ v.split('-')[1] +':00').getTime()])
      
    })
    //将已占用时间段转化为毫秒数，根据毫秒数判断大小
    let occupiedTime = []
    this.occupied.forEach((v)=>{
      occupiedTime.push([new Date('2020-01-01 '+ v.split('-')[0] +':00').getTime() , new Date('2020-01-01 '+ v.split('-')[1] +':00').getTime()])
      
    })
    // 设置每个时间段的状态
    this.times.forEach((item,i)=>{
      item['index'] = i
      item['status']=null
      //先修改已过期状态
      for (let i = 0; i < expiredTime.length; i++) {
        let time1 = new Date('2020-01-01 '+ item.endTime.split('-')[0] +':00').getTime()
        if(time1 > expiredTime[i][0] && time1 <= expiredTime[i][1]){
          item['status'] = 'expired'
        }
      }
      //先修改已占用状态
      for (let i = 0; i < occupiedTime.length; i++) {
        let time1 = new Date('2020-01-01 '+ item.endTime.split('-')[0] +':00').getTime()
        if(time1 > occupiedTime[i][0] && time1 <= occupiedTime[i][1]){
          item['status'] = 'occupied'
        }
      }
    })
  }

  order(item,i){
    if(this.readonly){
      return
    }
    //现在的时刻
    let avtiveHours = new Date().getHours()
    let avtiveMinutes = new Date().getMinutes()
    let avtiveTime = new Date('2020-01-01 '+ avtiveHours + ':' + avtiveMinutes +':00').getTime()
    let clickEndTime = new Date('2020-01-01 '+ item.endTime +':00').getTime()
    //只能预约之后的时间，且要提前半小时预约
    // if(clickEndTime - avtiveTime >= 30*60*1000){
      if(!item.status){
        //点击的是未预约的时间段
        //如果之前没有预约时间段，这个就是第一个
        if(this.orderTime.length == 0){
          item.status = 'order'
          this.orderTime.push(item)
          //将预约的时间段按索引重新排序
          this.orderTime = this.orderTime.sort((a,b)=>a.index-b.index)
          //抛出
          this.sure()
        } else {
          //如果之前已经有其他时间段，那后来只能选择相邻的时间段才行
          let indexs = this.orderTime.map(k=>k.index)
          if(indexs.includes(i+1) || indexs.includes(i-1)){
            item.status = 'order'
            this.orderTime.push(item)
            //将预约的时间段按索引重新排序
            this.orderTime = this.orderTime.sort((a,b)=>a.index-b.index)
            //抛出
            this.sure()
          } else {
            this.box.danger('只能选择连续的时间段')
          }
        }
      } else if(item.status == 'order'){
        //取消预约该时间段,只能取消所选时间段的第一个或最后一个
        let k = this.orderTime.findIndex(v=>v.endTime == item.endTime) 
        if(k == 0 || k == this.orderTime.length-1){
          item.status = null
          this.orderTime.splice(k,1)
          //抛出
          this.sure()
        }
      } else if(item.status == 'expired'){
          this.box.danger('该时间段已使用')
      } else if(item.status == 'occupied'){
          this.box.danger('该时间段已占用')
      }
    // } else {
    //   this.box.danger('该时间段已过去')
    // }
  }

  //点击确定
  sure(){
    if(this.orderTime.length){
      //注意第一个时间段是结束时间，要往前取半小时
      let order = this.times[this.orderTime[0]['index']-1]['endTime'] + '-' + this.orderTime[this.orderTime.length-1]['endTime']
      this.votedOrderTime.emit(order)
    }
    
  }

  // 鼠标是否在li上按下了
  /* ismousedown:boolean = false
  //鼠标在li上按下
  mousedown(event,item,i){
    this.ismousedown = true
    console.log('mousedown');
    console.log(item);
    
  }
  //鼠标在li上移动
  mouseover(event,item,i){
    console.log('mouseover');
    if(this.ismousedown){
      
      console.log(item);

    }

  }
  //鼠标移出ul
  mouseleave(event){
    console.log('mouseleave');
    if(this.ismousedown){
      this.ismousedown = false

    }

  }
  //鼠标在li上抬起
  mouseup(event,item,i){
    
    console.log('mouseup');
    if(this.ismousedown){
      this.ismousedown = false
      
      console.log(item);

    } 

  } */

}
